import _ from 'lodash'
import i18n from 'live/services/i18n'

export default (rigLists) => {
    _.map(rigLists, (rigs, area) => {
        setLabelsAndPriorities(rigs)

        return rigs
    })

    return rigLists
}

let setLabelsAndPriorities = function (data) {
    for (let i = 0; i < data.length; i++) {
        if (data[i]['installationType'])
            data[i]['label-installationType'] = i18n(data[i]['installationType'])

        if (data[i]['rigType'])
            data[i]['label-rigType'] = i18n(data[i]['rigType'])

        if (data[i]['name'])
            data[i]['label-name'] = data[i]['name'].toUpperCase()

        data[i]['label-pentagonCoefficient'] = data[i]['pentagonCoefficient'] ? data[i]['pentagonCoefficient'] : '-'

        data[i]['priority'] = data[i]['priority'] ? data[i]['priority'] : '-'
    }
}
